(function() {
  "use strict";
  angular.module("marketPlace.referral", ["marketPlace.common"]);
})();
